'use strict';

var NewGroupNameValidation = function NewGroupNameValidation() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        var valid = true;
        if (value) {
          valid = scope.isValidNewGroupName(value);
          ctrl.$setValidity('groupNameAlreadyUsed', valid);
        }
        return valid ? value : undefined;
      });
    }
  };
};
NewGroupNameValidation.$inject = [];
module.exports = NewGroupNameValidation;